export const getChangePasswordObject = (values, email) => {
	return {
		oldPassword: values?.oldPassword,
		newPassword: values?.newPassword,
		confirmPassword: values?.confirmPassword,
		userType: "DOC",
		username: email,
	};
};
